<template>
    <div>
        <StepOneForm v-show="step === 1" :coach="coach" :errors="errors" @step="onStep" />
        <StepTwoOpeningHours
            v-show="step === 2"
            :coach="coach"
            :errors="errors"
            :opening-hours="openingHours"
            @step="onStep"
        />
    </div>
</template>

<script>
import StepOneForm from './StepOneForm.vue'
import StepTwoOpeningHours from './StepTwoOpeningHours.vue'

export default {
    components: {
        StepOneForm,
        StepTwoOpeningHours
    },
    props: {
        coach: {
            type: Object,
            required: false,
            default: null
        },
        openingHours: {
            type: Array,
            required: false,
            default: null
        },
        phoneCountryCodes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            step: 1,
            form: null,
            errors: {}
        }
    },
    computed: {
        isInvalid() {
            return Object.keys(this.errors).length > 0
        }
    },
    methods: {
        async onStep({ data, nextStep }) {
            if (nextStep === 1) {
                Vuemit.fire('Button--sending-failed', true)
            }

            // after first step
            if (nextStep === 2) {
                this.form = data

                await this.validateStepOne()
            }

            // after second step, store opening hours into the formdata and submit id
            if (nextStep === 3) {
                this.form.set('opening_hours', data.opening_hours.toJson())
                this.form.set('start_date', data.start_date)
                await this.submitChanges()
            }

            if (!this.isInvalid) {
                this.step = nextStep
            }

            setTimeout(() => {
                $('.calendar-timetable').slick('setPosition')
            }, 1)
        },
        validateStepOne() {
            return axios.post('/novy-terapeut/validate', this.form)
                .then(() => {
                    this.errors = {}
                })
                .catch((e) => {
                    this.errors = e.response.data.errors
                    Vuemit.fire('Button--sending-failed', true)
                })
        },
        submitChanges() {
            // if the coach wasn't set, send request to store endpoint
            if (_.isEmpty(this.coach)) {
                return axios.post('/novy-terapeut', this.form).then(() => {
                    // redirect to the coach's detail
                    location.href = '/terapeute?type=waiting'
                })
                .catch((e) => {
                    this.errors = e.response.data.errors
                    this.step = 1
                    Vuemit.fire('Button--sending-failed', true)
                })
                // update endpoint
            } else {
                this.form.set('_method', 'PUT')

                return axios.post(`/terapeut/${this.coach.id}`, this.form).then(() => {
                    // redirect to the coach's detail
                    location.href = `/terapeut/${this.coach.id}`
                })
                .catch((e) => {
                    console.log(e.response)
                    this.step = 1
                    this.errors = e.response.data.errors
                    Vuemit.fire('Button--sending-failed', true)
                })
            }
        }
    }
}
</script>
